import React from "react";
import "./alertModal.scss";
import { useTranslation } from "react-i18next";

const AlertModal = (props) => {
    const { image, alertMessage, alertSubMessage, trueFn, className, trueBtn } = props;
    const { t } = useTranslation();

    return (
        <div className={`Modal-wrap ${className}`}>
            <div className="Modal AlertModal">
                <div className="Modal-body">
                    {image && (
                        <div className="img-wrap">
                            <img src={image} alt="" />
                        </div>
                    )}
                    <p className="text">{alertMessage}</p>
                    <p className="sub-text">{alertSubMessage}</p>
                </div>
                <div className="Modal-footer">
                    <button type="button" className="btn__radius" color="darkBlue" onClick={trueFn}>
                        {trueBtn || t("common.button.check")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AlertModal;
